<template>
  <nav
    class="
      navbar navbar-expand-md
      container-lg
      fixed-top
      navbar-light
      bg-light
      d-grid
      gap-3
      align-items-center
    "
    style="grid-template-columns: 1.2fr 4fr"
  >
    <router-link class="navbar-brand text-info" to="anasayfa">
      <h1>friendsquads</h1>
      <!-- <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button> -->
    </router-link>
    <div class="d-flex items-center me-3">
      <div class="input-group me-auto" style="width: 60%">
        <input
          class="form-control"
          type="search"
          placeholder="Search"
          aria-label="Search"
        />
        <button class="btn btn-sm btn-outline-info" type="submit">
          <i class="fas fa-search"></i>
        </button>
      </div>
      <ul class="nav flex-shrink-2">
        <li class="nav-item">
          <router-link type="button" class="btn" to="bildirimler">
            <i class="fas fa-bell fa-2x position-relative"
              ><span
                class="
                  position-absolute
                  start-50
                  translate-middle-y
                  badge
                  border border-light
                  rounded-circle
                  bg-info
                  p-2
                  mt-1
                "
                ><span class="visually-hidden"></span></span
            ></i>
          </router-link>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link text-dark"
            data-bs-toggle="dropdown"
            href="#"
            role="button"
            aria-expanded="false"
            ><img
              src="@/assets/avatar.jpg"
              style="width: 2rem"
              class="rounded-circle"
          /></a>
          <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" href="profil">Profil</a>
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <a class="dropdown-item" href="#">Çıkış Yap</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
